
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.67 10a2.67 2.67 0 11-5.34 0 2.67 2.67 0 015.34 0zm.66 0a3.33 3.33 0 11-6.66 0 3.33 3.33 0 016.66 0zm-3-1.67a.33.33 0 10-.66 0V10c0 .1.05.2.13.27l1.33 1a.33.33 0 00.4-.54l-1.2-.9v-1.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.49 11.63c-.47 0-.9-.27-1.09-.7h5.71a4.01 4.01 0 01-.09-1.37H3.8v-5.5a.7.7 0 01.7-.68h7c.39 0 .7.3.7.68V6c.5.03.97.14 1.4.33V4.06c0-1.14-.94-2.06-2.1-2.06h-7c-1.16 0-2.1.92-2.1 2.06v5.5c-.77 0-1.4.62-1.4 1.38 0 .22.05.42.15.6A2.6 2.6 0 003.49 13h5.86a4.01 4.01 0 01-1-1.38H3.48z"}})])
          )
        }
      }
    